module.exports = __webpack_public_path__ + "static/media/tab1.35855aad.svg";